///
/// EarthBrowser
///
/// Created by Matt Giger on 10/22/2026
/// Copyright (c) 2026 Geodata Labs
///
/// Video render mode flag (embed.html?render=1, see src/embed/renderHooks.ts).
/// Scene nodes consult it to drop interactive affordances that read badly in
/// a recorded clip - the spinning storm symbol, pulsing marker domes - while
/// keeping the informational geometry (tracks, cones). Dependency-free so
/// any node can import it.
///

let videoRenderMode = false

export function setVideoRenderMode(on: boolean): void {
	videoRenderMode = on
}

export function isVideoRenderMode(): boolean {
	return videoRenderMode
}

/** Cloud overlay look: "clean" white relief clouds, or "ir" enhanced-IR
 *  palette with a stylized key light (overlay_clouds.glsl cloudStyle) */
export type CloudStyle = "clean" | "ir"

let currentCloudStyle: CloudStyle = "clean"

export function setCloudStyle(style: string): void {
	currentCloudStyle = style === "ir" ? "ir" : "clean"
}

export function cloudStyle(): CloudStyle {
	return currentCloudStyle
}
